import React from "react";
import { Box, Flex, Heading, Image, Modal, Text } from "@catchoftheday/cg-components";
import { IMG_CCV_MODAL_INSTRUCTION } from "../../../../consts";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var CardCCVModal = function CardCCVModal(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose;
  return ___EmotionJSX(Modal, {
    sizeVariant: "medium",
    enableDefaultResponsiveStyles: false,
    isOpen: isOpen,
    onClose: onClose,
    onRequestClose: onClose
  }, ___EmotionJSX(Heading.h3, {
    mt: 0
  }, "3 or 4 Digit Card Verification Number"), ___EmotionJSX(Flex, {
    flexDirection: {
      xs: "column",
      md: "row"
    },
    alignItems: "center"
  }, ___EmotionJSX(Box, {
    mr: {
      md: 10
    }
  }, ___EmotionJSX(Text, {
    mt: 0
  }, "For your safety and security, our payment process requires that you enter your card's verification number."), ___EmotionJSX(Text, {
    my: 0
  }, "The verification number is a 3-digit or 4-digit number printed on the back of your card. It appears after and to right of your card number.")), ___EmotionJSX(Image, {
    src: IMG_CCV_MODAL_INSTRUCTION,
    width: 259,
    mt: {
      xs: 3,
      md: 0
    },
    alt: "Credit card verification number instruction"
  })));
};
export default CardCCVModal;